import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/button.scss';

export default class Button extends Component {

  render () {
    return (
      <button className={'button ' + this.props.className} onClick={this.props.onClick}>
        {this.props.children}
      </button>
    );
  }
}

Button.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
